import { useCallback } from 'react';
import { useErrorToast } from '../../components/common';

/** Map SDA ErrorToast API to survey-runtime `showError` naming */
export function useSurveyUiToast() {
  const { showErrorToast } = useErrorToast();
  const showError = useCallback((message) => showErrorToast(message), [showErrorToast]);
  return {
    showError,
  };
}
